import script from "./AppTestButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTestButton.vue?vue&type=script&setup=true&lang=js"

import "./AppTestButton.vue?vue&type=style&index=0&id=2bacc149&lang=less"

const __exports__ = script;

export default __exports__